import { DataItemStyles } from 'styles/components/atoms/DataItem'
import { bookingStatus } from 'utils/constants/booking-constants'
import DataItem from 'components/atoms/DataItem'
import HelperString from 'utils/helper-string'
import i18n from 'utils/i18n'
import React from 'react'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'
import _ from 'lodash'

const DataItemStatus = ({ status, children }) => {
	
	const currentStatus = _.isEmpty( status ) && !_.isEmpty( children ) ? children : status;
	
	return (
		<DataItem
			key={ HelperString.hash( 'data-item-status-tag', currentStatus ) }
			icon={ <DataItemStatusIcon>{ currentStatus }</DataItemStatusIcon> }
			textStyle={ [
				DataItemStyles.textStrong
			] }>
			
			{ i18n.t( `page.booking.status.${currentStatus}`) }
		</DataItem>
	)
}

export const DataItemStatusIcon = ({ status, children }) => {
	const currentStatus = _.isEmpty( status ) && !_.isEmpty( children ) ? children : status;
	
	let dataStyle = [ DataItemStyles.headerIcon ];
	
	switch( currentStatus ) {
		case bookingStatus.INVITE_ACCEPTED:
			dataStyle = [ dataStyle, DataItemStyles.headerIconGreen ];
			break;
		
		case bookingStatus.INVITE_REJECTED:
			dataStyle = [ dataStyle, DataItemStyles.headerIconRed ];
			break;
		
		case bookingStatus.ACTIVE:
			dataStyle = [ dataStyle, DataItemStyles.headerIconGreen ];
			break;
		
		case bookingStatus.CANCELLED:
			dataStyle = [ dataStyle, DataItemStyles.headerIconRed ];
			break;
		
		default:
			dataStyle = [ dataStyle, DataItemStyles.headerIconBlue ];
			break;
	}
	
	return (
		<Icon icon={ IconSystemConstants.STATUS } checked={ true } style={ dataStyle } />
	)
}

export default DataItemStatus
